import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// HeaderNoLogin
const HeaderNoLogin = (props) => {

  let navigate = useNavigate();
  let [pathname, setPathname] = useState('');

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  return (
    <div className="shadow2dp" style={{
      backgroundColor: '#008CC8',
      paddingTop: 40,
      paddingBottom: 20,
    }}>
      <Container>

        <Row style={{
          fontSize: 18,
        }}>

          <Col md="4" xs="12" style={{
            textAlign: 'left',
          }}>

            {/*<img src={require("../../../images/shabelab_log3.svg")}
              style={{
                marginRight: 20,
                width: 40,
                // height: 38,
            }} alt="shabelab log" />*/}

          </Col>

          <Col md="8" xs="12" style={{
            textAlign: 'right',
          }}>

          </Col>
        </Row>

      </Container>
    </div>
  )
}

export default HeaderNoLogin
